import { config } from "."

export function initChiefSlider() {
  const attemptToStopSlieder = setInterval(tryStartChiefSlider, 500)

  function tryStartChiefSlider() {
    if (typeof window.isChiefSliderLoaded !== 'undefined' && window.isChiefSliderLoaded) {
      window.homeChiefSliderPromo = new window.ChiefSlider('.slider', config)
      clearInterval(attemptToStopSlieder)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/impl/initChiefSlider.js